const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const INLINE = /^(application\/pdf|image\/)/;

// Apre/scarica un documento con un link firmato: funziona anche su Safari (macOS/iOS) e nella PWA
export const openSignedFile = async (getLink, contentType) => {
    const inline = INLINE.test(contentType || '');
    const win = inline ? window.open('', '_blank') : null;
    try {
        const { data } = await getLink();
        const url = `${API_BASE_URL}${data.url}`;
        if (win) win.location.href = url;
        else window.location.href = url;
    } catch (e) {
        if (win) win.close();
        throw e;
    }
};
